const push = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export const gtm = {
  checkAvailability: ({ checkIn, checkOut, adults, children }) =>
    push({
      event: "check_availability",
      check_in: checkIn,
      check_out: checkOut,
      adults,
      children,
    }),

  roomsSelected: ({ roomName, roomCount, totalPrice }) =>
    push({
      event: "rooms_selected",
      room_name: roomName,
      room_count: roomCount,
      total_price: Number(totalPrice),
    }),

  continueBooking: ({ rooms, totalPrice, checkIn, checkOut, adults, children }) =>
    push({
      event: "continue_booking",
      rooms: rooms.map((r) => ({ name: r.roomName, count: r.count })),
      total_price: Number(totalPrice),
      check_in: checkIn,
      check_out: checkOut,
      adults,
      children,
    }),

  checkoutInitiate: ({ rooms, totalPrice, checkIn, checkOut, adults, children }) =>
    push({
      event: "checkout_initiate",
      rooms: rooms.map((r) => ({ name: r.roomName, count: r.count })),
      total_price: Number(totalPrice),
      check_in: checkIn,
      check_out: checkOut,
      adults,
      children,
    }),

  bookingComplete: ({ bookingReference, totalPrice, rooms, checkIn, checkOut, adults, children }) =>
    push({
      event: "booking_complete",
      booking_reference: bookingReference,
      total_price: Number(totalPrice),
      rooms: rooms.map((r) => ({ name: r.roomName, count: r.count })),
      check_in: checkIn,
      check_out: checkOut,
      adults,
      children,
    }),
};
